// extracted by mini-css-extract-plugin
module.exports = {"container":"average-rank_container_3BvVp","noDataBox":"average-rank_noDataBox_2_Kl3","icon":"average-rank_icon_1egrd","chartBox":"average-rank_chartBox_1YJE6"};